import { Action } from '@ngrx/store';

export enum TestBarActionTypes {
  EnableConfirmButton = '[Test-bar Confirm Button] Enable',
  AvailableConfirmButton = '[Test-bar Confirm Button] Available',
  EnableConfirmButtonTooltip = '[Test-bar Confirm Button] Tooltip'
}

export class TestBarEnableConfirmButtonAction implements Action {
  readonly type = TestBarActionTypes.EnableConfirmButton;
  constructor(public payload: boolean) { }
}

export type TestBarActions = TestBarEnableConfirmButtonAction;

export class EnableConfirmButtonTooltipActions implements Action {
  readonly type = TestBarActionTypes.EnableConfirmButtonTooltip;
  constructor(public payload: string) { }
}

export type TooltipTestBarActions = EnableConfirmButtonTooltipActions;
